<script>
  import { isExternalUrl } from "$lib/utilities/url-helpers";

  export let id;
  export let url;
  export let isViewAllLink = false;

  let clazz = "";
  export let label = "";
  export { clazz as class };

  export let innerClass = "";

  export let highlightedElement = null;

  const isExternal = isExternalUrl(url);

  function sendHighlightedElement(e) {
    e.preventDefault();
    highlightedElement = { url, highlight: true };
  }

  function sendMouseOut(e) {
    e.preventDefault();
    highlightedElement = { url, highlight: false };
  }

  const linkHoverClasses = "hover:text-black";
  const divFocusClasses = "focus:bg-cyan-300 focus:drop-shadow-dropdown";
  const linkFocusClasses =
    "focus:text-black focus:bg-highlight focus:rounded-5 focus:outline-cyan-700";
</script>

<a
  {id}
  class="w-full font-bold decoration-1 underline-offset-2 text-black no-underline active:text-black text-size-12 lg:text-size-14 {linkHoverClasses} {linkFocusClasses} {clazz}"
  on:mouseenter={sendHighlightedElement}
  on:mouseleave={sendMouseOut}
  target={isExternal ? "_blank" : null}
  rel={isExternal ? "noopener noreferrer" : null}
  href={url}
  on:click
  data-sveltekit-reload
  aria-labelledby={label}
>
  <div
    class="px-24 py-16 lg:py-24 gap-24 flex justify-between hover:bg-indigo-50 {divFocusClasses} {innerClass}"
    class:bg-neutral-100={isViewAllLink}
    class:border-b={isViewAllLink}
    class:border-black={isViewAllLink}
  >
    <slot />
  </div>
</a>
